import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApprovalCriteria {
  Committee: any,
  AccreditationBody: any,
  BallotLevel: any,
  BallotType: any,
  BallotSubType: any,
  RecordType: any,
  RecordSubType: any,
  MinBallotDuration: number,
  VoteOptionCategory: any,
  DefaultVoteOptionValue: any,
  DefaultCommentOptionValueId: any,
  IsDefaultVoteOptionNonSelectable: boolean,
  IgnoredVoteOptionValueIds: any,
  CommentOptionCategory: any,
  DurationForWithdrawDisapproval: any,
  ThresholdPoints: any,
  AllowUsersToAddRemoveRecords: any,
  AllowUsersToAddRemoveCommittees: any,
  ACOperator1: any,
  ACPercentage1: any,
  ACVoteOptionValue1: any,
  ACOperator2: any,
  ACOperator3: any,
  ACPercentage3: any,
  ACVoteOptionValue3: any,
  IsConsensusApprovalApplied: any,
  ConsensusApprovalPercentage: number | null,
  DurationForWithdrawDisapprovalRecirculation: number | null,
  AdditionalBallotConfigurationMembershipPositions: any,
  Id: string,
  TenantId: string,
  Active: boolean,
  Deleted: boolean,
  CreatedBy: string,
  ModifiedBy: string,
  CreatedDate: string,
  ModifiedDate: string,
  IsDirty: boolean,
  IsNew: boolean,
  Success: boolean,
  SysMessages: null,
  SysMessagesKey: null,
  SysMessagesType: null
  [key: string]: any; // For additional dynamic properties
}

interface BallotState {
  selectedApprovalCriteria: ApprovalCriteria | null;
}

const initialState: BallotState = {
  selectedApprovalCriteria: null,
};

const selectedApprovalCrteriaSlice = createSlice({
  name: "approvalCriteria",
  initialState,
  reducers: {
    setSelectedApprovalCriteria: (state, action: PayloadAction<ApprovalCriteria>) => {
      state.selectedApprovalCriteria = action.payload;
    },
    updateSelectedBallotField: (
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) => {
      if (state.selectedApprovalCriteria) {
        state.selectedApprovalCriteria[action.payload.field] = action.payload.value;
      }
    },
    clearBallotDetails: (state) => {
      state.selectedApprovalCriteria = null;
    },
  },
});

export const { setSelectedApprovalCriteria, clearBallotDetails } =
  selectedApprovalCrteriaSlice.actions;

export default selectedApprovalCrteriaSlice.reducer;